// extracted by mini-css-extract-plugin
export default {"root":"AddComment_root__jLP9k","avatar":"AddComment_avatar__IKYYD","form":"AddComment_form__SSOwn"};